import {NgModule} from '@angular/core';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared';
import {CoreComponent} from './core.component';
import {NavbarComponent} from './components/navbar';
import {SidebarComponent} from './components/sidebar';
import {NavbarUserMenuComponent} from './components/navbar/navbar-user-menu';
import {ForbiddenComponent} from './components/forbidden/forbidden.component';
import {SidebarTriggerComponent} from './components/sidebar/sidebar-trigger/sidebar-trigger.component';
import {SidebarDrawerComponent} from './components/sidebar/sidebar-drawer/sidebar-drawer.component';
import {SidebarContentComponent} from './components/sidebar/sidebar-content/sidebar-content.component';
import {UserCardComponent} from './components/user-card/user-card.component';

@NgModule({
    declarations: [
        CoreComponent,
        NavbarComponent,
        SidebarComponent,
        NavbarUserMenuComponent,
        ForbiddenComponent,
        SidebarTriggerComponent,
        SidebarDrawerComponent,
        SidebarContentComponent,
        UserCardComponent,
    ],
    exports: [CoreComponent, NavbarComponent],
    imports: [CommonModule, FormsModule, SharedModule, RouterModule],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {}
